export var LINK_ACCOUNT_ERROR_TYPES = {
  SERVER_ERROR: 'SERVER_ERROR',
  THIRD_PARTY_ERROR: 'THIRD_PARTY_ERROR'
};